import { List, Map } from 'immutable';
import { handPlayable, handReason, optionReason, sourceOption, stepTargets } from '../ActiveGame/options';
import { picksPokemon, TRAINER } from '../Picks/constants';

/** Played as it is (Bill, Professor Oak). */
export const AT_ONCE = 'at-once';
/** Its first step picks a Pokémon on the board (Potion, Gust of Wind). */
export const ON_A_POKEMON = 'on-a-pokemon';
/** Its first step picks cards in the menu (Energy Retrieval, Computer Search). */
export const IN_THE_MENU = 'in-the-menu';

/**
 * How a Trainer card in your hand is played now, for the hand menu and for dragging it onto the board: the one place
 * that decides it, from the server's options.
 *
 * @returns {{ how: string, reason: ?string, source: Map, steps: List }} how it's played, why it can't be (or null),
 *   and the picks' source and steps
 */
export function trainerPlay(card, options) {
  const position = card.get('order');
  const steps = card.get('trainer_steps') || List();
  const source = Map({ kind: TRAINER, handPosition: position, name: card.get('name') });

  if (handPlayable(options, 'trainers', position)) {
    return { how: AT_ONCE, reason: null, source, steps };
  }

  const targets = steps.size ? stepTargets(sourceOption(options, source), 0) : [];
  const reason = targets.length ? null : (handReason(options, 'trainers', position) || optionReason(undefined));
  return { how: picksPokemon(steps.get(0)) ? ON_A_POKEMON : IN_THE_MENU, reason, source, steps };
}
